import './env';
import 'react-notifications/lib/notifications.css';

import { Route } from 'react-router-dom';
import { Box, Typography } from "@material-ui/core";
import React from 'react';
import { useSelector } from 'react-redux';
import { Admin, Resource, Layout, AppBar, SearchInput, SimpleForm, TextInput, List, usePermissions } from 'react-admin';
import { NotificationContainer } from 'react-notifications';
import { PublisherList, PublisherEdit, PublisherCreate } from './publishers';
// import { NetworkList, NetworkEdit, NetworkCreate } from './networks'
import { AdvertiserList, AdvertiserEdit, AdvertiserCreate } from './advertisers';
import { SiteList, SiteEdit, SiteCreate } from './sites';
import { AdunitList, AdunitEdit, AdunitCreate } from './adunits.js';
import { ShareEntityCreate, ShareEntityEdit } from './share';
import { SiteBatchCreate, SiteBatchEdit } from './batch_site';
import { PlacementBatchCreate, PlacementBatchEdit } from './batch_placement';
import { PlacementList, PlacementEdit, PlacementCreate } from './placements';
import { OrderList, OrderEdit } from './orders';
import { LineItemList } from './line_items';
import { ExperimentList, ExperimentEdit, ExperimentCreate } from './experiments';
import { SegmentList, SegmentEdit, SegmentCreate } from './segments';
import { AudienceList, AudienceEdit, AudienceCreate } from './audiences';
import { ClicksList, ClicksCreate, ClicksEdit } from './clicks';
import { ConversionsList, ConversionsCreate, ConversionsEdit } from './conversions';
import { AuctionsList, AuctionsCreate, AuctionsEdit } from './auctions';
import { DiscrepanciesList, DiscrepanciesCreate, DiscrepanciesEdit } from './discrepancies';
import { AuctionOptimizerReportList, AuctionOptimizerReportEdit, AuctionOptimizerReportCreate } from './auction_optimizer';
import { AdViewabilityReportList, AdViewabilityReportCreate, AdViewabilityReportEdit } from './ad_viewability';
import { AdDomainsReportList, AdDomainsReportCreate, AdDomainsReportEdit } from './ad_domains';
import { SecretsList, SecretsCreate, SecretsEdit } from './secrets';
import { AdstxtReportList, AdstxtReportCreate, AdstxtReportEdit } from './adstxtreports';
import { AdQualityReportsList, AdQualityReportsCreate, AdQualityReportsEdit } from './adquality_reports';
import { AdMalwareReportList, AdMalwareReportCreate, AdMalwareReportEdit } from './ad_malware';
import { SegmentReportsList, SegmentReportEdit, SegmentReportCreate } from './segment_reports';
import { UserList, UserEdit, UserCreate } from './users';
import { DomainList, DomainCreate, DomainEdit } from './domains';
import { AdvertiserDomainList, AdvertiserDomainCreate, AdvertiserDomainEdit } from './advertiser_domains';
import { MissingSitesList, MissingSitesCreate, MissingSitesEdit } from './missing_sites';
import { DomainBatchCreate, DomainBatchEdit } from './batch_domain';
import { AlarmList, AlarmShow } from './alarms';
// import { AdstxtList } from './adstxt';
import { AdServingCostList } from './adcost';
import { DOCostReportList } from './do_cost_report';
import { IVTList } from './ivt';
// import { IVTDomainList } from './ivt_domains';
import { RealtimeDashboardList, RealtimeDashboardCreate, RealtimeDashboardEdit } from './realtime';
import { TopSitesList } from './topsites';
import { PublisherEarningReportList, PublisherEarningReportEdit, PublisherEarningReportCreate } from './pubreports';
import { TrafficReportList, TrafficReportEdit, TrafficReportCreate } from './traffic_reports';
import { AdvertiserCpmReportList, AdvertiserCpmReportEdit, AdvertiserCpmReportCreate } from './advertiser_cpm';
import { CarbonPublisherEarningReportList, CarbonPublisherEarningReportEdit, CarbonPublisherEarningReportCreate } from './carbon/pubreports';
import { CarbonDiscrepanciesList, CarbonDiscrepanciesEdit, CarbonDiscrepanciesCreate } from './carbon/discrepancies';
import { CarbonizerReportList, CarbonizerReportEdit, CarbonizerReportCreate } from './carbon/carbonizer';
import { CarbonRealtimeReportList, CarbonRealtimeReportEdit, CarbonRealtimeReportCreate } from './carbon/realtime';
// import { CarbonCalculator } from './carbon/calculator';
import CarbonDashboard from './carbon/dashboard';
import { CarbonSettings } from './carbon/settings';
import { CampaignList, CampaignEdit, CampaignCreate } from './campaigns';
import { AdQualityRuleList, AdQualityRuleEdit, AdQualityRuleCreate } from './ad_quality_rules';
import { DealList, DealEdit, DealCreate } from './deals';
import { AdCampaignList, AdCampaignEdit, AdCampaignCreate } from './adcampaigns';
import { CreativeList, CreativeEdit, CreativeCreate } from './creatives';
import { AdvertiserCampaignList, AdvertiserCampaignEdit, AdvertiserCampaignCreate } from './advertiser/campaigns';
import { AdvertiserCreativeList, AdvertiserCreativeEdit, AdvertiserCreativeCreate } from './advertiser/creatives';
import { AdvertiserAccountList } from './advertiser/account';
import { AdvertiserIpListList, AdvertiserIpListEdit, AdvertiserIpListCreate } from './advertiser/ip_lists';
// import { ClusterList } from './cluster';
import { BidderList, BidderEdit, BidderCreate } from './bidders';
import { adstxtRegexToPatterns, parseBidderSyncUrl, isAdvertiserRole } from './components/utils';
import { IpListList, IpListEdit, IpListCreate } from './ipLists';
import { SettingsList, SettingsEdit } from './settings';
import { DataPurgeList } from './components/data_purge';
import { PredictionsList } from './predictions';
import { LogsList } from './logbook';
import { ToolsList } from './tools';
import { GamAccountList, GamAccountCreate, GamAccountEdit } from './gam_accounts';
import { GamChatList } from './gam_chat';
import { InsightsAssistantList } from './insights_assistant';
import Dashboard from './Dashboard/Dashboard';
import ExperimentDashboard from './Dashboard/ExperimentDashboard';
import authProvider from './authProvider';
import { createTheme } from '@material-ui/core/styles';
import { AccountTree, AccountCircle, AccountBalance, BarChart, FilterTiltShift, Share, Lock, Language,
  BrandingWatermark, Description, Settings, MenuBook, PhotoLibrary, ShoppingCart, FindInPage, AddShoppingCart,
  LocalMall, Business, MonetizationOn, Traffic, Public, AlarmOn, BuildRounded, LocalShipping, ViewList, CallSplit, Speed }
  from '@material-ui/icons';
import ChatIcon from '@material-ui/icons/Chat';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import AssistantIcon from '@material-ui/icons/QuestionAnswer';
import EcoSharpIcon from '@material-ui/icons/EcoSharp';
import pink from '@material-ui/core/colors/pink';
import { createTenantTheme } from './theme';
import dataProvider from './dataprovider';
import TreeMenu from '@bb-tech/ra-treemenu';
import { GlobalSearchInput } from './global_search';
import { NotificationsComponent } from './notifications';
import { LoginPage, LoginPasswordForgot, LoginPasswordReset } from './LoginPage';
import { OrganizationList, OrganizationEdit, OrganizationCreate } from './organizations';

const roles = require('./components/roles.json');

const theme = createTheme({
  palette: {
    type: 'dark',
    primary: pink,
    secondary: pink,
  },
  status: {
    danger: 'orange',
  },
  typography: {
    fontSize: 12
  },
  spacing: 6,
  props: {
  //   MuiButton: {
  //     size: 'small',
  //   },
  //   MuiFilledInput: {
  //     margin: 'dense',
  //   },
  //   MuiFormControl: {
  //     margin: 'dense',
  //   },
  //   MuiFormHelperText: {
  //     margin: 'dense',
  //   },
  //   MuiIconButton: {
  //     size: 'small',
  //   },
  //   MuiInputBase: {
  //     margin: 'dense',
  //   },
  //   MuiInputLabel: {
  //     margin: 'dense',
  //   },
    MuiListItem: {
      dense: true,
    },
  //   MuiOutlinedInput: {
  //     margin: 'dense',
  //   },
  //   MuiFab: {
  //     size: 'small',
  //   },
  //   MuiTable: {
  //     size: 'small',
  //   },
  //   MuiTextField: {
  //     margin: 'dense',
  //   },
  //   MuiToolbar: {
  //     variant: 'dense',
  //   },
  },
  overrides: {
    RaList: {
      root: {
        marginTop: '30px'
      }
    }
  }
});

// Both the ops and advertiser-scoped IP list resources upload their CSV the
// same way: a `file_upload` FileInput field whose rawFile gets base64-encoded
// into `file_data` before it reaches the backend. Defined once so the two
// resource names aren't repeated at each of the three interceptor sites below.
const IP_LIST_RESOURCES = ['ip_lists', 'advertiser_ip_lists'];

function readFileAsDataURL(file) {
  let result_base64 = new Promise((resolve, reject) => {
    let fileReader = new FileReader();
    fileReader.onload = () => resolve(fileReader.result);
    fileReader.onerror = reject;
    fileReader.readAsDataURL(file.rawFile);
  });
  return result_base64;
}
const nobidDataProvider = {
  ...dataProvider
  , getList: (resource, params) => {
    // console.log('### list resource: '+resource);
    // console.log('### list params: '+JSON.stringify(params));
    if (params.filter && params.filter.batch_file && params.filter.batch_file.rawFile) {
      let file = params.filter.batch_file.rawFile
      let resultBase64 = readFileAsDataURL(file.rawFile)
      return dataProvider.getList(resource, {
        ...params,
        data: {
          ...params.data,
          file_data: resultBase64
        }
      });
    } else {
      return dataProvider.getList(resource, params)
    }
  }
  , create: (resource, params) => {
    // console.log('### create resource: '+resource);
    // console.log('### create params: '+JSON.stringify(params));
    if (resource === 'creatives' && params.data && params.data.image) {
      params.data.image = [params.data.image];
      const newPictures = params.data.image.filter(
        p => p.rawFile instanceof File
      );

      if (!newPictures || newPictures.length <= 0) {
        delete params.image;
        return dataProvider.create(resource, params);
      }
      return Promise.all(newPictures.map(readFileAsDataURL))
        .then(base64Pictures =>
          base64Pictures.map(picture64 => ({
            src: picture64
          }))
        )
        .then(transformedNewPictures =>
          dataProvider.create(resource,
            { ...params, data: { ...params.data, file_data: transformedNewPictures[0] } }
          )
        );
    } else if (IP_LIST_RESOURCES.includes(resource) && params.data && params.data.file_upload && params.data.file_upload.rawFile instanceof File) {
      return readFileAsDataURL(params.data.file_upload).then(base64 => {
        // eslint-disable-next-line no-unused-vars
        const { file_upload, ...rest } = params.data;
        return dataProvider.create(resource, { ...params, data: { ...rest, file_data: base64 } });
      });
    } else {
      return dataProvider.create(resource, params);
    }
  }
  , update: (resource, params) => {
    // console.log('### update resource: '+resource);
    // console.log('### update params: '+JSON.stringify(params));
    if (resource == 'creatives' && params.data && params.data.image) {
      params.data.image = Array.isArray(params.data.image) ? params.data.image : [params.data.image];
      const newPictures = params.data.image.filter(
        p => p.rawFile instanceof File
      );

      if (!newPictures || newPictures.length <= 0) {
        delete params.image;
        return dataProvider.update(resource, params);
      }
      return Promise.all(newPictures.map(readFileAsDataURL))
        .then(base64Pictures =>
          base64Pictures.map(picture64 => ({
            src: picture64
          }))
        )
        .then(transformedNewPictures =>
          dataProvider.update(resource,
            { ...params, data: { ...params.data, file_data: transformedNewPictures[0] } }
          )
        );
    } else if (IP_LIST_RESOURCES.includes(resource) && params.data && params.data.file_upload && params.data.file_upload.rawFile instanceof File) {
      return readFileAsDataURL(params.data.file_upload).then(base64 => {
        // eslint-disable-next-line no-unused-vars
        const { file_upload, ...rest } = params.data;
        return dataProvider.update(resource, { ...params, data: { ...rest, file_data: base64 } });
      });
    } else if (IP_LIST_RESOURCES.includes(resource) && params.data && params.data.file_upload) {
      // file_upload field is present but no new rawFile (e.g. user opened the
      // Upload tab without uploading). Strip it so the backend doesn't see a
      // stale object.
      const { file_upload, ...rest } = params.data;
      return dataProvider.update(resource, { ...params, data: rest });
    } else {
      return dataProvider.update(resource, params);
    }
  }
  , getOne: (resource, params) => {
    // console.log('### getOne resource:', resource);
    // console.log(`### getOne params: ${JSON.stringify(params)}`);
    if (resource === 'bidders') {
      // Back-fill the friendly ads.txt entries from a legacy stored regex so the
      // edit form shows them. Only fills when our format is recognized; leaves
      // patterns empty (and regex untouched) otherwise.
      return dataProvider.getOne(resource, params).then(res => {
        const data = res && res.data;
        const cfg = data && data.adstxt_config;
        if (cfg && cfg.regex && !cfg.patterns) {
          const parsed = adstxtRegexToPatterns(cfg.regex);
          if (parsed) cfg.patterns = parsed;
        }
        // Back-fill the sync URL builder fields from a legacy stored sync_url.
        if (data && data.sync_url && !data.sync_partner_endpoint) {
          const parsedSync = parseBidderSyncUrl(data.sync_url);
          if (parsedSync) {
            data.sync_partner_endpoint = parsedSync.endpoint;
            data.sync_macro = parsedSync.macro;
          }
        }
        return res;
      });
    }
    return dataProvider.getOne(resource, params);
  },
};

function isAdminRole (permissions) {
  return permissions && (permissions.role === 'admin' || permissions.role === 'super_admin');
}

function isAuthorized (permissions, resourceId) {
  const { role, resources, disabled_resources } = permissions;
  // Check if org has disabled this resource
  if (disabled_resources && disabled_resources.includes(resourceId)) return false;
  if (resources && resources.length > 0) {
    return resources.includes(resourceId) || roles[role].defaultResources.includes(resourceId);
  } else if (roles[role]) {
    return roles[role].defaultResources.includes(resourceId);
  } else {
    return false;
  }
}

function apiResources (permissions) {
  return roles["api"].defaultResources.map( r => !isAuthorized (permissions, r) ? <Resource name={`${r}`} /> : null)
    .filter( rComponenet => rComponenet !== null );
}
function localTime() {
  const e = document.getElementById('localTime');
  if (e) {
     e.innerHTML = Intl.DateTimeFormat(navigator.languages, {timeStyle: 'medium', dateStyle: 'medium'}).format(new Date());
  }
  setTimeout(localTime, 1000);
}
localTime();
const MyAppBar = (props) => {
  const { permissions } = usePermissions();
  const loading = useSelector((state) => state.admin.loading);
  const logoUrl = permissions && permissions.branding && permissions.branding.logo_url;
  return(
  <AppBar {...props}>
    <Box flex="1" style={{ display: 'flex', alignItems: 'center' }}>
      { logoUrl && <img src={logoUrl} alt="Logo" style={{ maxHeight: 30, marginRight: 12 }} /> }
      <Typography id="react-admin-title"></Typography>
    </Box>
    <Box flex="1" style={{textAlign: 'right'}}>
      <Typography style={{fontFamily: 'sans-serif'}}><span id='localTime'></span></Typography>
    </Box>
    <GlobalSearchInput/>
    { isAdminRole(permissions) && <NotificationsComponent loading={loading}/> }
  </AppBar>
)};
const MyLayout = (props) => <Layout {...props} appBar={MyAppBar} />;

// Build tenant-aware theme from branding stored in localStorage
const brandingJson = localStorage.getItem('nobid_branding');
const tenantBranding = brandingJson ? JSON.parse(brandingJson) : null;
const appTheme = tenantBranding ? createTenantTheme(tenantBranding) : theme;
const appTitle = (tenantBranding && tenantBranding.display_name) ? `${tenantBranding.display_name} Insights` : 'NoBid Insights';

const App = () => (
  <Admin
    title={appTitle}
    theme={appTheme}
    dashboard={Dashboard}
    loginPage={LoginPage}
    customRoutes={[
      <Route exact path="/loginPasswordForgot" component={LoginPasswordForgot} noLayout/>,
      <Route exact path="/loginPasswordReset" component={LoginPasswordReset} noLayout/>
    ]}
    authProvider={authProvider}
    dataProvider={nobidDataProvider}
    menu={TreeMenu}
    layout={MyLayout}
  >
    {permissions => [
      isAuthorized(permissions, 'inventory') ? <Resource name="inventory" options={{ label: "> Inventory", isMenuParent: true }} icon={Business}/> : null,
      // isAuthorized(permissions, 'networks') ? <Resource name="networks" list={NetworkList} edit={NetworkEdit} create={NetworkCreate} icon={AccountBox} options={{ menuParent: "inventory"}} /> : null,
      isAuthorized(permissions, 'publishers') ? <Resource name="publishers" list={PublisherList} edit={PublisherEdit} create={(isAdminRole(permissions))? PublisherCreate:null} icon={AccountBalance} options={{ menuParent: "inventory"}} /> : null,
      isAuthorized(permissions, 'sites') ? <Resource name="sites" list={SiteList} edit={SiteEdit} create={(isAdminRole(permissions))?SiteCreate:null} icon={Language} options={{ menuParent: "inventory"}} /> : null,
      isAuthorized(permissions, 'domains') ? <Resource name="domains" list={DomainList} edit={DomainEdit} create={DomainCreate} options={{ label: 'Domains', menuParent: "inventory" }} icon={Public} /> : null,
      isAuthorized(permissions, 'placements') ? <Resource name="placements" list={PlacementList} edit={PlacementEdit} create={PlacementCreate} icon={BrandingWatermark} options={{ menuParent: "inventory"}} /> : null,
      isAuthorized(permissions, 'batch') ? <Resource name="batch" list={SiteBatchCreate} edit={SiteBatchEdit} options={{ label: 'Batch Sites', menuParent: "inventory" }} icon={Description} /> : null,
      isAuthorized(permissions, 'batchp') ? <Resource name="batchp" list={PlacementBatchCreate} edit={PlacementBatchEdit} options={{ label: 'Batch Placements', menuParent: "inventory" }} icon={Description} /> : null,
      isAuthorized(permissions, 'batchd') ? <Resource name="batchd" list={DomainBatchCreate} edit={DomainBatchEdit} options={{ label: 'Batch Domains', menuParent: "inventory" }} icon={Description} /> : null,
      isAuthorized(permissions, 'adunits') ? <Resource name="adunits" list={AdunitList} edit={AdunitEdit} create={AdunitCreate} options={{ menuParent: "inventory"}} />: null,
      isAuthorized(permissions, 'gam_accounts') ? <Resource name="gam_accounts" list={GamAccountList} edit={GamAccountEdit} create={GamAccountCreate} icon={AccountTree} options={{menuParent: 'inventory' }} /> : null,
      isAuthorized(permissions, 'delivery') ? <Resource name="delivery" options={{ label: "> Delivery", isMenuParent: true }} icon={LocalShipping}/> : null,
      isAuthorized(permissions, 'bidders') ? <Resource name="bidders" list={BidderList} edit={BidderEdit} create={isAdminRole(permissions) ? BidderCreate : null} options={{ label: 'Bidders', menuParent: 'delivery' }} icon={MonetizationOn} /> : null,
      isAuthorized(permissions, 'campaigns') ? <Resource name="campaigns" list={CampaignList} edit={CampaignEdit} create={CampaignCreate} options={{ label: 'Traffic Rules', menuParent: 'delivery' }} icon={Traffic} /> : null,
      isAuthorized(permissions, 'ad_quality_rules') ? <Resource name="ad_quality_rules" list={AdQualityRuleList} edit={AdQualityRuleEdit} create={AdQualityRuleCreate} options={{ label: 'Ad Quality Rules', menuParent: 'delivery'}} icon={FilterTiltShift} /> : null,
      isAuthorized(permissions, 'adcampaigns') ? <Resource name="adcampaigns" list={isAdvertiserRole(permissions) ? AdvertiserCampaignList : AdCampaignList} edit={isAdvertiserRole(permissions) ? AdvertiserCampaignEdit : AdCampaignEdit} create={isAdvertiserRole(permissions) ? AdvertiserCampaignCreate : AdCampaignCreate} options={{ label: 'Campaigns', menuParent: 'delivery' }} icon={ShoppingCart} /> : null,
      isAuthorized(permissions, 'creatives') ? <Resource name="creatives" list={isAdvertiserRole(permissions) ? AdvertiserCreativeList : CreativeList} edit={isAdvertiserRole(permissions) ? AdvertiserCreativeEdit : CreativeEdit} create={isAdvertiserRole(permissions) ? AdvertiserCreativeCreate : CreativeCreate} options={{ label: 'Creatives', menuParent: 'delivery' }} icon={PhotoLibrary} /> : null,
      isAdvertiserRole(permissions) ? <Resource name="advertiser_account" list={AdvertiserAccountList} options={{ label: 'Account', menuParent: 'delivery' }} icon={AccountBalance} /> : null,
      isAuthorized(permissions, 'advertiser_ip_lists') ? <Resource name="advertiser_ip_lists" list={AdvertiserIpListList} edit={AdvertiserIpListEdit} create={AdvertiserIpListCreate} options={{ label: 'IP Lists', menuParent: 'delivery' }} icon={ViewList} /> : null,
      isAuthorized(permissions, 'audiences') ? <Resource name="audiences" list={AudienceList} edit={AudienceEdit} create={AudienceCreate} options={{ label: 'Audiences', menuParent: 'delivery' }} icon={FilterTiltShift} /> : null,
      <Resource name="segments" />,
      // isAuthorized(permissions, 'advertiser_domains') ? <Resource name="advertiser_domains" list={AdvertiserDomainList} edit={AdvertiserDomainEdit} create={AdvertiserDomainCreate} options={{ label: 'Advertiser Domains', menuParent: "delivery" }} icon={Public} /> : null,
      isAuthorized(permissions, 'deals') ? <Resource name="deals" list={DealList} edit={DealEdit} create={DealCreate} options={{ label: 'Deals', menuParent: 'delivery' }} icon={LocalMall} /> : null,
      isAuthorized(permissions, 'advertisers') ? <Resource name="advertisers" list={AdvertiserList} edit={AdvertiserEdit} create={(isAdminRole(permissions))?AdvertiserCreate:null} options={{menuParent: 'delivery' }} icon={AccountBalance} /> : null,
      isAuthorized(permissions, 'experiments') ? <Resource name="experiments" list={ExperimentList} edit={ExperimentEdit} create={ExperimentCreate} options={{menuParent: 'delivery' }} icon={CallSplit} /> : null,
      isAuthorized(permissions, 'ip_lists') ? <Resource name="ip_lists" list={IpListList} edit={IpListEdit} create={IpListCreate} options={{ label: 'IP Lists', menuParent: 'delivery' }} icon={ViewList} /> : null,
      // isAuthorized(permissions, 'orders') ? <Resource name="orders" list={OrderList} edit={(isAdminRole(permissions))?OrderEdit:null} icon={AddShoppingCart} options={{ menuParent: "delivery"}} /> : null,
      // isAuthorized(permissions, 'line_items') ? <Resource name="line_items" list={LineItemList} icon={ViewList} options={{ menuParent: "delivery"}} /> : null,
      // isAuthorized(permissions, 'adstxtstatus') ? <Resource name="adstxtstatus" list={AdstxtList} options={{ label: 'Ads.txt' }} icon={PlaylistAddCheck} /> : null,
      // (['admin', 'network_manager', 'publisher'].includes(role)) ? <Resource name="ivt_domains" list={IVTDomainList} options={{ label: 'IVT Domains' }} icon={ReportOff} /> : null,
      <Resource name="reports" options={{ label: "> Reports", isMenuParent: true }} icon={BarChart}/>,
      isAuthorized(permissions, 'predictions') ? <Resource name="predictions" list={PredictionsList} options={{ label: 'Bid Predictions', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'ivt') ? <Resource name="ivt" list={IVTList} options={{ label: 'IVT', menuParent: "reports"}} icon={BarChart} /> : null,
      isAuthorized(permissions, 'adcost') ? <Resource name="adcost" list={AdServingCostList} options={{ label: 'Ad Requests', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'do_cost_report') && isAdminRole(permissions) ? <Resource name="do_cost_report" list={DOCostReportList} options={{ label: 'Cost Explorer', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'topsites') ? <Resource name="topsites" list={TopSitesList} options={{ label: 'Market Movers', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'realtime') ? <Resource name="realtime" list={RealtimeDashboardList} edit={RealtimeDashboardEdit} create={RealtimeDashboardCreate} options={{ label: 'Realtime Dash', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'pubreports') ? <Resource name="pubreports" list={PublisherEarningReportList} edit={PublisherEarningReportEdit} create={PublisherEarningReportCreate} options={{ label: (permissions.role === 'advertiser')?'Activity Report':'Earning Reports', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'clicks') ? <Resource name="clicks" list={ClicksList} edit={ClicksEdit} create={ClicksCreate} options={{ label: 'Click Reports', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'conversions') ? <Resource name="conversions" list={ConversionsList} edit={ConversionsEdit} create={ConversionsCreate} options={{ label: 'Conversion Reports', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'auctions') ? <Resource name="auctions" list={AuctionsList} edit={AuctionsEdit} create={AuctionsCreate} options={{ label: 'Auction Reports', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'auction_optimizer') ? <Resource name="auction_optimizer" list={AuctionOptimizerReportList} create={AuctionOptimizerReportCreate} edit={AuctionOptimizerReportEdit} options={{ label: 'Optimizer', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'discrepancies') ? <Resource name="discrepancies" list={DiscrepanciesList} edit={DiscrepanciesEdit} create={DiscrepanciesCreate} options={{ label: 'Discrepancy', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'adViewability') ? <Resource name="adViewability" list={AdViewabilityReportList} edit={AdViewabilityReportEdit} create={AdViewabilityReportCreate} options={{ label: 'Viewability', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'ad_domains') ? <Resource name="ad_domains" list={AdDomainsReportList} edit={AdDomainsReportEdit} create={AdDomainsReportCreate} options={{ label: 'Ad Domains', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'missing_sites') ? <Resource name="missing_sites" list={MissingSitesList} edit={MissingSitesEdit} create={MissingSitesCreate} options={{ label: 'Missing Sites', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'ad_malware') ? <Resource name="ad_malware" list={AdMalwareReportList} edit={AdMalwareReportEdit} create={AdMalwareReportCreate} options={{ label: 'Ad Malware', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'adstxtreports') ? <Resource name="adstxtreports" list={AdstxtReportList} edit={AdstxtReportEdit} create={AdstxtReportCreate} options={{ label: 'Adstxt Coverage', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'adquality_reports') ? <Resource name="adquality_reports" list={AdQualityReportsList} edit={AdQualityReportsEdit} create={AdQualityReportsCreate} options={{ label: 'Ad Quality Reports', menuParent: "reports" }} icon={BarChart} /> : null,
      // isAuthorized(permissions, 'segmentreports') ? <Resource name="segmentreports" list={SegmentReportsList} edit={SegmentReportEdit} create={SegmentReportCreate} options={{ label: 'Segments', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'traffic_reports') ? <Resource name="traffic_reports" list={TrafficReportList} edit={TrafficReportEdit} create={TrafficReportCreate} options={{ label: 'Traffic Reports', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'advertiser_cpm') ? <Resource name="advertiser_cpm" list={AdvertiserCpmReportList} edit={AdvertiserCpmReportEdit} create={AdvertiserCpmReportCreate} options={{ label: 'CPM Comparison', menuParent: "reports" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'gam_chat') ? <Resource name="gam_chat" list={GamChatList} options={{ label: 'GAM Chat', menuParent: "reports" }} icon={ChatIcon} /> : null,
      isAuthorized(permissions, 'exp_dash') && isAdminRole(permissions) ? <Resource name="exp_dash" list={ExperimentDashboard} options={{ label: 'Experiments', menuParent: "reports" }} icon={CallSplit} /> : null,
      isAuthorized(permissions, 'carbon/dashboard') ? <Resource name="carbon/dashboard" list={CarbonDashboard} edit={CarbonDashboard} create={CarbonDashboard} options={{ label: 'Dashboard', menuParent: "carbon" }} icon={Speed} /> : null,
      isAuthorized(permissions, 'insights_assistant') ? <Resource name="insights_assistant" list={InsightsAssistantList} options={{ label: 'Insights Assistant', menuParent: "carbon" }} icon={AssistantIcon} /> : null,
      isAuthorized(permissions, 'carbon/pubreports') ? <Resource name="carbon/pubreports" list={CarbonPublisherEarningReportList} edit={CarbonPublisherEarningReportEdit} create={CarbonPublisherEarningReportCreate} options={{ label: 'Reports', menuParent: "carbon" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'carbon/discrepancies') ? <Resource name="carbon/discrepancies" list={CarbonDiscrepanciesList} edit={CarbonDiscrepanciesEdit} create={CarbonDiscrepanciesCreate} options={{ label: 'Discrepancies', menuParent: "carbon" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'carbon/realtime') ? <Resource name="carbon/realtime" list={CarbonRealtimeReportList} edit={CarbonRealtimeReportEdit} create={CarbonRealtimeReportCreate} options={{ label: 'Realtime', menuParent: "carbon" }} icon={BarChart} /> : null,
      isAuthorized(permissions, 'carbon/carbonizer') ? <Resource name="carbon/carbonizer" list={CarbonizerReportList} edit={CarbonizerReportEdit} create={CarbonizerReportCreate} options={{ label: 'Optimizer', menuParent: "carbon" }} icon={BarChart} /> : null,
      // isAuthorized(permissions, 'carbon/calculator') ? <Resource name="carbon/calculator" list={CarbonCalculator} edit={CarbonCalculator} create={CarbonCalculator} options={{ label: 'Calculator', menuParent: "carbon" }} icon={Speed} /> : null,
      isAuthorized(permissions, 'carbon/settings') ? <Resource name="carbon/settings" list={CarbonSettings} edit={CarbonSettings} create={CarbonSettings} options={{ label: 'Settings', menuParent: "carbon" }} icon={Settings} /> : null,
      isAuthorized(permissions, 'carbon') ? <Resource name="carbon" options={{ label: "> Analytics Adapter", isMenuParent: true }} icon={EcoSharpIcon}/> : null,
      isAdminRole(permissions) ? <Resource name="admin" options={{ label: "> Admin", isMenuParent: true }} icon={BuildRounded}/> : null,
      isAuthorized(permissions, 'users') ? <Resource name="users" options={{ label: 'Users', menuParent: "admin" }} list={UserList} edit={UserEdit} create={UserCreate} icon={AccountCircle} /> : null,
      // (role === 'admin') ? <Resource name="cluster" options={{ label: 'Cluster' }} list={ClusterList} icon={Computer} /> : null,
      isAuthorized(permissions, 'logs') ? <Resource name="logs" list={LogsList} options={{ label: 'Logbook', menuParent: "admin" }} icon={MenuBook} /> : null,
      isAuthorized(permissions, 'alarms') ? <Resource name="alarms" list={AlarmList} show={AlarmShow} options={{ label: 'Alarms', menuParent: "admin" }} icon={AlarmOn} /> : null,
      isAuthorized(permissions, 'share') ? <Resource name="share" list={ShareEntityCreate} edit={ShareEntityEdit} options={{ label: 'Share', menuParent: "admin" }} icon={Share} /> : null,
      isAuthorized(permissions, 'secrets') ? <Resource name="secrets" list={SecretsList} create={SecretsCreate} edit={SecretsEdit} options={{ label: 'Secrets', menuParent: "admin" }} icon={Lock} /> : null,
      isAuthorized(permissions, 'settings') ? <Resource name="settings" list={SettingsList} edit={SettingsEdit} options={{ label: 'Settings', menuParent: "admin" }} icon={Settings} /> : null,
      isAdminRole(permissions) ? <Resource name="data_purge" list={DataPurgeList} options={{ label: 'Data Purge', menuParent: "admin" }} icon={DeleteSweepIcon} /> : null,
      isAuthorized(permissions, 'tools') ? <Resource name="tools" list={ToolsList} options={{ label: 'Tools', menuParent: "admin" }} icon={BuildRounded} /> : null,
      isAuthorized(permissions, 'organizations') ? <Resource name="organizations" list={OrganizationList} edit={OrganizationEdit} create={OrganizationCreate} options={{ label: 'Organizations', menuParent: "admin" }} icon={Business} /> : null,

      [...apiResources(permissions)],
      <NotificationContainer/>
    ]}

  </Admin>
);

export default App;